'use client';

import type { PropsWithChildren } from 'react';
import { useHasMounted } from '@frameio/vapor';

/**
 * A component that will prevent children client components from rendering server on the server.
 *
 * @param {Object} props - Props object for ClientRenderBoundary component.
 * @param {React.ReactNode} props.children - The content to be rendered within the boundary.
 * @param {React.ReactNode} [props.fallback=null] - Fallback content to render on the server, such as an empty panel or loading indicator
 * @returns {React.ReactNode} - Returns either the provided children or fallback content based on the rendering context.
 */
export const ClientRenderBoundary = ({
  children,
  fallback = null,
}: PropsWithChildren<{
  fallback?: React.ReactNode;
}>) => {
  const mounted = useHasMounted();
  if (!mounted) {
    return fallback;
  }

  return children;
};
